<script>
export default {
  name: "Tab",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {},
    destoryOnHide: {
      type: Boolean,
      default: false,
    },
  },
  render(h) {
    const tabPanels = this.$slots.default.filter(slot => slot.componentOptions);
    const tabNum = tabPanels.length;
    const tabLength = Math.floor((100 / tabNum) * 100) / 100;
    const tabs = tabPanels.map(slot => {
      const options = slot.componentOptions;
      const name = options.propsData.name;
      const isActive = name === this.value;

      return h(
        "div",
        {
          class: {
            Tab__toggle: true,
            "is-active": isActive,
          },
          style: {
            width: `${tabLength}%`,
          },
          key: name,
          on: {
            click: () => this.handleTabItemClick(name),
          },
        },
        [
          h(
            "span",
            {
              class: {
                Tab__link: true,
              },
            },
            [options.propsData.label]
          ),
        ]
      );
    });
    if (this.$slots.afterToggles) {
      tabs.push(this.$slots.afterToggles);
    }

    const toggleContainer = h(
      "div",
      {
        class: { Tab__toggles: true },
      },
      tabs
    );

    const contentContainer = h(
      "div",
      {
        class: { Tab__content: true },
      },
      [
        this.$slots.beforePanels,
        this.destoryOnHide
          ? tabPanels.filter(panel => panel.componentOptions.propsData.name === this.value)
          : tabPanels,
        this.$slots.afterPanels,
      ]
    );

    return h(
      "div",
      {
        class: { Tab: true },
      },
      [toggleContainer, contentContainer]
    );
  },
  methods: {
    handleTabItemClick(name) {
      if (name === this.value) {
        return;
      }

      this.$emit("change", name);
    },
  },
};
</script>

<style lang="scss">
.Tab__toggles {
  display: flex;
  align-items: center;
}

.Tab__toggle {
  text-align: center;
}
</style>
